'use client';

import { useEffect } from 'react';

import { ApiWebApp } from '@/lib/citibox/sdk/ApiWebApp';
import { CitiboxMobileSDK } from '@/lib/citibox/sdk/MobileSdk';

const CourierAppApiAddition = () => {
  useEffect(() => {
    (window as unknown as Window).CitiboxCourierWebApp = ApiWebApp;

    const onDOMContentLoaded = () => {
      CitiboxMobileSDK.sdkInfo();
      CitiboxMobileSDK.characteristicsSDK();
      CitiboxMobileSDK.blePermissionsStatus();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onDOMContentLoaded);
    } else {
      onDOMContentLoaded();
    }

    return () => {
      document.removeEventListener('DOMContentLoaded', onDOMContentLoaded);
    };
  }, []);

  return null;
};

export default CourierAppApiAddition;
